import { API } from 'aws-amplify';
import {
  COURSE_LMS_GATEWAY_ENDPOINT_NAME,
  JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
  USER_API_GATEWAY_ENDPOINT_NAME,
  JOB_SCRAPING_API_NAME,
} from '../aws-exports';

export async function getSubscriptionPlans() {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/v2/subscription-plan'
  );
  return response;
}

export async function updateSubscriptionplans(body) {
  const response = await API.put(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/subscription-plan',
    { body: body }
  );
  return response;
}

export async function getUser() {
  const response = await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/me', {});
  return response;
}

export async function getThemes() {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/theme',
    {}
  );
  return response;
}

export async function getCoinsSettings() {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/coin-settings',
    {}
  );
  return response;
}

export const getRatingTemplates = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/rating-template', {});

export const deleteRatingTemplates = async (body) => {
  await API.del(USER_API_GATEWAY_ENDPOINT_NAME, '/api/rating-template', {
    body,
  });
};

export const addRatingTemplate = async (templateData) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/rating-template', {
    body: templateData,
  });

export const updateRatingTemplate = async (templateData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/rating-template', {
    body: templateData,
  });

export async function getGroupsSessionVisibility() {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/groups/session-visibility',
    {}
  );
  return response;
}

export async function getAllUsers(params) {
  let queryParams = {};
  if (params) {
    const { query, offset, limit, sortByField, sortByOrder, userType } = params;
    if (query || offset || limit || sortByField || sortByOrder || userType) {
      queryParams = {
        queryStringParameters: params,
      };
    }
  }
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/users',
    queryParams
  );
  return response;
}

export async function getFilteredUserReferEarn(params) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/filter-referral-details`,
    { body: params, headers: {} }
  );
  return response;
}
export async function createReferrer(body) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/new-user-referral',
    { body, headers: {} }
  );
  return response;
}
export async function addNewTheme(themeData) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/theme',
    { body: themeData, headers: {} }
  );
  return response;
}

export async function updateTheme(themeData) {
  const response = await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/theme', {
    body: themeData,
    headers: {},
  });
  return response;
}

export const deleteTheme = (themeId) =>
  API.del(USER_API_GATEWAY_ENDPOINT_NAME, '/api/theme', {
    body: { themeId },
  });

export async function getSessionSetting() {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/theme-settings',
    {}
  );
}
export async function updateThemeSettings(themeSettings) {
  const response = await API.put(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/theme-settings',
    {
      body: themeSettings,
    }
  );
  return response;
}

export async function insertCoinPack(coinPackData) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/coin-pack',
    { body: coinPackData, headers: {} }
  );
  return response;
}

export async function insertCouponCode(couponCodeData) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/coin-coupon',
    { body: couponCodeData, headers: {} }
  );
  return response;
}

export async function updateCoinPack(coinPackData) {
  const response = await API.put(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/coin-pack',
    { body: coinPackData, headers: {} }
  );
  return response;
}

export async function updateGroup(groupData) {
  const response = await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/group', {
    body: groupData,
    headers: {},
  });
  return response;
}

export const getUserById = async (userId) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/user', {
    queryStringParameters: { userId },
  });

export const getAllQuestions = async (body) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/questions', {
    queryStringParameters: {
      includeConcept: true,
      ...body,
    },
  });

export const getBookingQuestions = async (bookingId) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/booking/question', {
    queryStringParameters: { bookingId },
  });

export const addQuestion = async (questionObj) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/question', {
    body: questionObj,
  });

export const updateQuestion = async (questionObj) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/question', {
    body: questionObj,
  });

export async function updateQuestionsBatch(allQuestions) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/questions',
    { body: [...allQuestions] }
  );
  return response;
}

export const getArchivedQuestions = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/questions', {
    queryStringParameters: {
      archived: true,
    },
  });

export const addQuestionToArchive = async (questionId) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/archived-question/archive',
    { body: { questionId } }
  );

export const restoreQuestionFromArchive = async (questionId) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/archived-question/restore',
    { body: { questionId } }
  );

export const deleteQuestionFromArchive = async (questionId) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/archived-question/delete',
    { body: { questionId } }
  );

export const getUnverifiedUsers = async () =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/coach/sub-topic/unverified-profiles',
    {}
  );

export const updateUserVerification = async (body) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/update-user', {
    body,
  });

export async function getBookings(filterObj) {
  return await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/filter-bookings/admin',
    {
      body: filterObj,
    }
  );
}

export async function adminUpdateBooking(bookingData) {
  const response = await API.put(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/booking',
    { body: bookingData, headers: {} }
  );
  return response;
}

export async function getDetailedBooking(bookingId) {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/booking?bookingId=${bookingId}`
  );
  return response;
}

export const getBookingRecordings = async (roomId100ms) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/booking/recordings', {
    queryStringParameters: { roomId100ms },
  });

export const getBookingRecordingsBrowser = async (roomId100ms) =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/booking/browserRecordings',
    {
      queryStringParameters: { roomId100ms },
    }
  );

// new coupons api
export const fetchCoupons = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coupon');

export const createSingleCoupon = async (apiData) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coupon', {
    body: apiData,
  });

export const editSingleCoupon = async (apiData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coupon', {
    body: apiData,
  });

export const createMultipleCoupons = async (apiData) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coupon/bulk', {
    body: apiData,
  });

export const editMultipleCoupons = async (apiData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coupon/bulk', {
    body: apiData,
  });

export const deleteMultipleCoupons = async (apiData) =>
  await API.del(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coupon/bulk', {
    body: apiData,
  });

export const getCompanies = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/companies', {});

export const mergeCompanies = async (mergeBody) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/companies/merge', {
    body: mergeBody,
  });

export const verifyCompany = async (companyId) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/companies/verify', {
    body: { companyId },
  });

export const filterIncomingCoaches = async (apiData) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/coach/filter-incoming-coaches',
    {
      body: apiData,
    }
  );

export const getCohortInfoForCoach = async () =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/cohort/learning`
  );

export const getCoachandCohortList = async () => {
  return await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/list');
};

export const filterOnboardingCoaches = async (apiData) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/coach/filter-onboarded-coaches',
    {
      body: apiData,
    }
  );

export const getPendingKycCoaches = async (apiData) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/coach/filter-kyc-pending-coaches',
    {
      body: apiData,
    }
  );

export const getKYCDetailsByCaochId = async (coachId) =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/coach/get-kyc-details-by-coach-id?userId=${coachId}`,
    {}
  );

export const addCoachRolesAfterOnboarding = async (apiData) => {
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/coach/add-coach-roles-after-onboarding',
    {
      body: apiData,
    }
  );
};

export const getCoachDetails = async (coachId) => {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/coach/get-coach-by-coach-id?userId=${coachId}`,
    {}
  );
};

export const getCoachAvailability = async (coachId) => {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/coach/availabilityByCoachId/${coachId}`,
    {}
  );
};

export const updateKYCStatus = async (apiData) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/coachOnboardingStage/update-kyc-assessment-stage',
    {
      body: apiData,
    }
  );

export const getAllCoaches = async (queryStringParameters = {}) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/coaches', {
    queryStringParameters,
  });

export const verifyCoachKyc = async (coach) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/kyc-detail', {
    body: coach,
  });

export const createCoach = async (coach) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/create', {
    body: coach,
  });

export const updateCoach = async (coach) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/update', {
    body: coach,
  });

export const deleteCoach = async (userId) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/delete', {
    body: { userId },
  });

export const getAllCohorts = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/cohort', {});
export const getAlmaxCohorts = async () =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v2/cohort/almax',
    {}
  );

export const getCohortById = async (cohortId) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, `/cohort/${cohortId}`, {});

export const createNewCohort = async (cohortData) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/cohort', {
    body: cohortData,
  });

export const updateCohort = async (cohortData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/cohort', {
    body: cohortData,
  });

export const createCohortV3 = async (cohortData) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v3/cohort', {
    body: cohortData,
  });

export const updateCohortV3 = async (cohortData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v3/cohort', {
    body: cohortData,
  });

export const getScheduledCohorts = async ({ page = 1, limit = 20, status, courseType } = {}) => {
  const qs = new URLSearchParams({ page, limit });
  if (status) qs.set('status', status);
  if (courseType) qs.set('courseType', courseType);
  return await API.get(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v3/cohort/scheduled-cohorts?${qs}`, {});
};

export const createScheduledCohort = async (body) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v3/cohort/scheduled-cohorts', { body });

export const updateScheduledCohort = async (id, body) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v3/cohort/scheduled-cohorts/${id}`, { body });

export const deleteScheduledCohort = async (id) =>
  await API.del(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v3/cohort/scheduled-cohorts/${id}`, {});

export const getSubscriptions = async (params) => {
  let queryParams = {};
  if (params) {
    const { query, almax } = params;
    if (query || almax) {
      queryParams = {
        queryStringParameters: params,
      };
    }
  }
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/almax-cohort',
    queryParams
  );
};

export const bulkAddUsersToAlmax = async (cohortData) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/almax-cohort', {
    body: cohortData,
  });
// export const bulkAddEmailToAlmax = async (cohortData) =>
//   await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/almax-cohort-bulk', {
//     body: cohortData,
//   });

export async function bulkAddEmailToAlmax(payload) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/almax-cohort-bulk',
    { body: payload }
  );
  return response;
}

export const updateSubscription = async (cohortData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/almax-cohort', {
    body: cohortData,
  });

export const updateCoachExpertise = async ({ coachId, payload }) =>
  await API.put(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/coach/sub-topic?coachId=${coachId}`,
    {
      body: payload,
    }
  );

export const getCoachSubTopics = async (coachId) =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/coach/sub-topic?coachId=${coachId}`
  );

export const getAllQuesModules = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/question-module');

export const addQuesModule = async (body) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/question-module', {
    body,
  });

export const updateQuesModule = async (body) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/question-module', {
    body,
  });

export const deleteQuesModule = async (body) =>
  await API.del(USER_API_GATEWAY_ENDPOINT_NAME, '/api/question-module', {
    body,
  });

export const getLoggedInUserRoles = async () =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v2/rbac/logged-in-user'
  );

export const getAdminUsers = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/rbac/users', {});

export const assignAdminRoles = async (body) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/rbac/users', {
    body,
  });

export const deleteAdmin = async (body) =>
  await API.del(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/rbac/users', {
    body,
  });

export const getAdminRoles = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/rbac/roles', {});

export const upsertAdminRole = async (roleData) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v2/rbac/roles', {
    body: roleData,
  });

export const getListOfCoachProfile = async () =>
  await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/profile-verification',
    {}
  );

export const getCoachInfoByID = async (userId) =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/info', {
    queryStringParameters: { userId },
  });

export const verifyCoachProfile = async (body) =>
  await API.put(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/info', {
    body,
  });

export const adminCreateBooking = async (body) =>
  await API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/booking', {
    body,
  });

export const invokeQuestionRecommenderWebhook = async (body) =>
  await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/question-recommender-webook',
    { body }
  );

// enrolled - free users API

export async function getProjectSubmissionList(payload) {
  const response = await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/submissions',
    { body: payload }
  );
  return response;
}

export const updateProjectStatus = async (payload) =>
  await API.put(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/admin/project/status', {
    body: payload,
  });

export const allowProjectResubmit = async (payload) =>
  await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/reevaluation/status',
    {
      body: payload,
    }
  );

export const assignEvaluatorInProject = async (payload) =>
  await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/evaluator',
    {
      body: payload,
    }
  );

export async function getEvaluatorListForProjectSubmission(courseType) {
  const crsType =
    courseType && courseType === 'dataScience' ? 'data-science' : courseType;
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    crsType
      ? '/api/coaches?courseType=' + crsType + '&role=project_evaluator'
      : '/api/coaches?role=project_evaluator'
  );
  return response;
}

export const getDefaultReferralAmount = async () =>
  await API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/default-referral-amount');

export const updateDefaultReferralAmount = async (body) =>
  await API.put(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/default-referral-amount',
    { body }
  );

export async function getProjectNotAcceptReason() {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/project/rejected-reasons'
  );
  return response;
}

export async function submitProjectEvaluation(projectId, body) {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/coach-feedback/' + projectId,
    { body }
  );
}

// get All Projects
export async function fetchAllProjects(goalType) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/project-ids?goalType=' + goalType
  );
  return response;
}

// get Projects Categories
export async function fetchAllProjectCategories() {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/project-category-ids'
  );
  return response;
}

// get AlmaX Assignments List
export async function getAlmaXAssignmentList(payload) {
  const response = await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/submissions',
    { body: payload }
  );
  return response;
}
// progress-call api
export async function uploadProgressCallCsv(payload) {
  const response = await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/progress/upload-progress-call-data',
    {
      body: payload,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response;
}

export async function getProgressCallData(
  page,
  cohortName,
  typeName,
  email,
  ratingFilter
) {
  const queryStringParameters = { page };

  if (cohortName) queryStringParameters.cohortName = cohortName;
  if (typeName) queryStringParameters.typeName = typeName;
  if (email) queryStringParameters.email = email;
  if (ratingFilter)
    queryStringParameters.ratingFilter = JSON.stringify(ratingFilter);

  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/progress/get-progress-call-data',
    {
      queryStringParameters,
    }
  );
  return response;
}
export async function getStudentGroups(page) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/studentGroups?page=${page}`
  );
  return response;
}
export const createStudentGroups = async (payload) =>
  await API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/studentGroups', {
    body: payload,
  });
export async function getStudentGroupGlobalData() {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/studentGroups/global`
  );
  return response;
}
export async function updateStudentGroup(body, groupId) {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/studentGroups/${groupId}`,
    {
      body,
    }
  );
}

export const deleteStudentGroup = async (groupId) => {
  await API.del(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/studentGroups/${groupId}`
  );
};

export async function getCohortName() {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/progress/global'
  );
  return response;
}

// AlmaX Assignments admin-status update
export const updateAlmaXAssignmentStatus = async (payload) =>
  await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/status',
    {
      body: payload,
    }
  );

// Assign AlmaX Evaluator
export const assignAlmaXEvaluatorInProject = async (payload) =>
  await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/evaluator',
    {
      body: payload,
    }
  );

// Increase AlmaX max-attempts
export const increaseMaxAttempt = async (payload) =>
  await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/increase-max-attempt',
    {
      body: payload,
    }
  );

// Get AlmaX assignment all submissions
export const getAllAlmaXSubmissions = async (
  goalType,
  assignmentId,
  studentId
) =>
  await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/' +
      goalType +
      '/' +
      assignmentId +
      '?studentId=' +
      studentId
  );

// Update AlmaX assignment evaluation
export async function submitAlmaXAssignmentEvaluation(body) {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/coach-feedback',
    { body }
  );
}

// Get all AlmaX assignment List
export async function getAllAlmaXAssignmentList(goalType) {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/assignment/assignment-ids',
    {
      queryStringParameters: {
        goalType,
      },
    }
  );
}

// get Payment flows List
export async function getPaymentFlowsList(page, pageSize) {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v2/payment-link?page=' + page + '&pageSize=' + pageSize
  );
  return response;
}

// fetch payment details
export async function fetchPaymentDetails(body) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v3/payment-link/payment-details',
    { body }
  );
  return response;
}

// craete payment link
export async function createPaymentLink(body) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v3/payment-link/create',
    { body }
  );
  return response;
}

// cancle payment link
export async function canclePaymentLink(body) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v3/payment-link/cancel',
    {
      body,
    }
  );
  return response;
}

// Get All User metrics
export async function getAllUserMetrics() {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/metrics'
  );
  return response;
}

// Get All User details
export async function getAllUserDetails(body) {
  const response = await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/filter-user',
    { body }
  );
  return response;
}

// Get Cohort list
export async function getCohortList(courseType) {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v2/cohort/learning',
    {
      queryStringParameters: { courseType },
    }
  );
  return response;
}

// Get Student Module Details
export async function getModulesDetails(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/modules',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}
export async function getAbcatDetails(courseType, studentId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/abcat/userAbCatAllData',
    {
      queryStringParameters: {
        courseType,
        studentId,
      },
    }
  );
  return response;
}

// Get Lesson Details
export async function getLessonDetails(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/lessons',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}

// Get Quiz Assessment
export async function getQuizAssessment(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/assessments',
    {
      queryStringParameters: {
        goalType,
        userId,
        assessmentType: 'competency',
      },
    }
  );
  return response;
}

// Get Cpastone Project Score Details
export async function getCapstoneProjectScoreDetails(
  projectId,
  goalType,
  studentId
) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/project/' + goalType + '/' + projectId,
    {
      queryStringParameters: {
        studentId,
      },
    }
  );
  return response;
}

// Get Capstone Project
export async function getCapstoneProject(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/projects',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}

// Get Coding Assignment
export async function getCodingAssignment(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/coding-assessment',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}

// Get User Assignment
export async function getUserAssignment(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/assignments',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}

// Get Student Tracks Info
export const getUserTracks = async (userId) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/users/tracks?userId=${userId}`
  );
};

// Get Student Mentorship Info
export const getUserMentorship = async (userId) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/users/mentorship-sessions?userId=${userId}`
  );
};

// Get ALmaX Criteria
export async function getAlmaXCriteria(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/almaX-criteria',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}

// Get Student Cohort History
export async function getStudentCohortHistory(userId) {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/user-subscription/cohort-change-history',
    {
      queryStringParameters: {
        userId,
      },
    }
  );
  return response;
}

// Get Student Cerificates
export async function getStudentCertificates(goalType, studentId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/certificates',
    {
      queryStringParameters: {
        goalType,
        studentId,
      },
    }
  );
  return response;
}

// Get Student Cerificates
export async function getStudentAuditLogs(courseType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/audit-logs',
    {
      queryStringParameters: {
        courseType,
        userId,
      },
    }
  );
  return response;
}

// Get course progress information
export async function getCourseProgress(goalType, userId) {
  const response = await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/performance/metrics',
    {
      queryStringParameters: {
        goalType,
        userId,
      },
    }
  );
  return response;
}

// Get student Profile information
export async function getStudentProfileInfo(studentId) {
  const response = await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/post-payment-onboarding/student',
    {
      queryStringParameters: {
        studentId,
      },
    }
  );
  return response;
}

// Get all job groups
export const getJobGroups = async (body) =>
  await API.post(JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME, '/api/jobgroup', {
    body,
  });

// Get all job titles
export const getJobTitles = async () =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobtitle/allJobTitles'
  );

// Get all companies
export const getAllCompanies = async () =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/company/getAllCompanies'
  );

// Get all Recruiters for a company
export const getAllRecruitersByCompanyID = async (companyId) =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/recruiter/allRecruiters',
    {
      queryStringParameters: { companyId },
    }
  );

// Get all students available for placement
export const getStudents = async () =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/student/getAllStudents'
  );

// Add a new company
export const addCompany = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/company/actions/create/company',
    { body, headers: { 'Content-Type': 'multipart/form-data' } }
  );

// Add a new recruiter
export const addRecruiter = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/recruiter/actions/create/recruiter',
    { body, headers: { 'Content-Type': 'multipart/form-data' } }
  );

// Add a new job title
export const addJobTitle = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobtitle/actions/create/jobTitle',
    { body }
  );

// get job group by id
export const getJobGroupById = async (queryParams) =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/getJobGroup',
    {
      queryStringParameters: queryParams,
    }
  );
// create a new job group
export const createNewJobGroup = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/actions/create/jobGroup',
    { body }
  );

// Get all rounds for a jobGroup
export const getAllRoundsForJobGroup = async (queryParams) =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/roundsForGroup',
    {
      queryStringParameters: queryParams,
    }
  );

// Schedule an Interview for a round
export const ScheduleInterview = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/actions/addSchedule',
    { body }
  );
// Get all scheduled interview rounds
export const GetScheduledInterviews = async (body) =>
  await API.post(JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME, '/api/round', {
    body,
  });
// update status of round
export const updateRoundStatus = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/actions/updateStatus',
    {
      body,
    }
  );

// Add Students to existing job group
export const AddStudentsToJobGroup = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/actions/update/addStudents',
    { body }
  );

export const updateJobDescriptionDoc = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/actions/update/jobDescriptionDoc',
    { body, headers: { 'Content-Type': 'multipart/form-data' } }
  );
// Update existing job group
export const updateJobGroup = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/actions/update/jobGroup',
    { body }
  );

// set offer made status on a job application
export const setStatusOfJobApplication = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobapplication/actions/update/updateStatusOfApplication',
    { body }
  );

// temporaririly close a job group
export const updateStatusOfJobGroupById = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/actions/update/statusOfJobGroup',
    { body }
  );

// delete a round by group id and roundNumber
export const deleteRound = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/actions/deleteRoundFromJobGroup',
    { body }
  );

// bulk update round status
export const bulkUpdateRoundStatus = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/actions/bulkUpdateRoundStatus',
    { body }
  );

// get stream token
export const getStreamToken = async () => {
  return await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/chat/getStreamToken'
  );
};

export const getStudentActivities = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/activity/getStudentActivities',
    {
      body,
    }
  );
export const getAdminActivities = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/adminActivity/getAdminActivities',
    {
      body,
    }
  );
export const completeAction = async (body) => {
  return await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/activity/addNewActivity',
    {
      body,
    }
  );
};

// getAllPlacementSpoc
export const getAllPlacementSpoc = async () =>
  await API.get(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/placementSpoc'
  );

// update Active status of Job Group
export const updateActiveStatusOfGroup = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/jobgroup/actions/update/activeStatusOfGroup',
    {
      body,
    }
  );

// Add deadline for assignment rounds
export const AddDeadlineForAssignment = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/actions/addDeadline',
    {
      body,
    }
  );

// bulk update  interview schedules
export const bulkUpdateInterviewSchedules = async (body) =>
  await API.post(
    JOB_DASHBOARD_V2_API_GATEWAY_ENDPOINT_NAME,
    '/api/round/actions/bulkUpdateSchedule',
    { body }
  );

// classroom
export const getListOfCohorts = async () => {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/cohort/learning`
  );
};

export const getListOfGroups = async () => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/studentGroups/getAllGroupsList`
  );
};

export const generateAwsClientLink = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/generate-link`,
    {
      body,
    }
  );
};

export const generateClientLinkAccToServer = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/generate-link-v2`,
    {
      body,
    }
  );
};

export const updateHandoutsForSpecificClassroom = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/update-handout`,
    {
      body,
    }
  );
};
export const updateHandoutsForSpecificGroup = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/update-css-handout`,
    {
      body,
    }
  );
};

export const updateVideoForSpecificClassroom = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/update-video-v2`,
    {
      body,
    }
  );
};
export const updateVideoForSpecificGroup = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/update-css-video`,
    {
      body,
    }
  );
};

export const getClassesForSpecificCohort = async (cohortName) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/classes-by-cohort?cohortName=${cohortName}`
  );
};
export const getClassesForSpecificGroup = async (groupName, page) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/classes-by-groups?groupName=${groupName}&page=${page}`
  );
};


export const fetchClassRoomVideoV2 = async (cloudType, videoItemKey) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/v2/classroom/get-signed-url`,
    {
      body: {
        cloudType,
        itemKey: videoItemKey,
      },
    }
  );
};

export const fetchHandoutsForClassroom = async (handoutItemKey) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/classroom/get-signed-url?ItemKey=${handoutItemKey}`
  );
};
export const fetchISAUrl = async (handoutItemKey) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/classroom/get-isa-signed-url?ItemKey=${handoutItemKey}`
  );
};

// get all abcat extension student
export const getAllAbcatExtensionStudent = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/career/list-all-abcat-users',
    { body }
  );
};
export const updateClassPublicStatus = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/v2/classroom/update-class-public-status',
    { body }
  );
};



export const updateAlmaxExpiryDate = async ({ userId, courseType, date }) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/career/almax/update-expiry-date',
    { body: { userId, courseType, date } }
  );
};

export const generateModuleCertificateUrl = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/certificate/module`,
    {
      body,
    }
  );
};
export const generateAssessmentCertificateUrl = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/certificate/assessment`,
    {
      body,
    }
  );
};
export const updateAssessmentCertificateUrl = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/certificate/assessment`,
    {
      body,
    }
  );
};
export const generateProjectCertificateUrl = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/certificate/project',
    { body }
  );
};
export const updateProjectCertificateUrl = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/certificate/project',
    { body }
  );
};
export const generateCourseCertificateUrl = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/certificate/course`,
    {
      body,
    }
  );
};

export const generateNewIdCard = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/certificate/newIdCard`,
    {
      body,
    }
  );
};

export const fetchUserSubscriptionDetails = async (userId, courseType) => {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/user-subscription`,
    {
      queryStringParameters: {
        userId,
        courseType,
      },
    }
  );
};

export const getSubPlanTypes = async (apiData) => {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v3/payment-link/sub-plan-types?courseType=${apiData?.courseType}&planType=${apiData?.planType}`
  );
};

export const updateAlmaXExtension = async (body) => {
  return await API.put(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/career/almax/extension/status`,
    {
      body,
    }
  );
};

export const getAllabcatReport = async (
  page,
  email,
  course,
  shortlisted,
  decision,
  almaXCohort,
  start,
  end
) => {
  const queryParams = {
    page,
    email,
    course,
    shortlisted,
    decision,
    almaXCohort,
  };

  // Only add start and end if they have values
  if (start && end) {
    queryParams.start = start;
    queryParams.end = end;
  }

  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/abcat/get-report`,
    {
      queryStringParameters: queryParams,
    }
  );
};
// Fix getAllAlmaxStudents to use filters object for query params
export const getAllAlmaxStudents = async (page, filters = {}) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/userAlmax/get-almax-users`,
    {
      queryStringParameters: {
        page,
        ...filters,
      },
    }
  );
};

export const downloadAlmaxData = async (
  email,
  course,
  shortlisted,
  decision,
  almaXCohort,
  start,
  end
) => {
  const queryParams = {
    email,
    course,
    shortlisted,
    decision,
    almaXCohort,
  };

  // Only add start and end if they have values
  if (start && end) {
    queryParams.start = start;
    queryParams.end = end;
  }

  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/abcat/download-report',
    {
      queryStringParameters: queryParams,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const getAllConstants = async () => {
  return await API.get(COURSE_LMS_GATEWAY_ENDPOINT_NAME, `/api/abcat/global`);
};

export const evaluateAbCat = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/abcat/update-report',
    {
      body,
    }
  );
};
export const updateAlmaxUserStatus = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/userAlmax/update-user-almax-status',
    {
      body,
    }
  );
};
export const sendEmail = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/abcat/email-sent',
    {
      body,
    }
  );
};

// get jobs

export const getJobs = async (body) => {
  return await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/job-board/get-job-descriptions',
    {
      body,
    }
  );
};

export const downloadJobData = async (body) => {
  const response = await API.post(
    JOB_SCRAPING_API_NAME,
    '/api/jobs/downloadData',
    {
      body,
      responseType: 'blob', // Important: Tell Amplify to expect a Blob
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response;
};

export const getAllScrapeRequest = async (page) => {
  return await API.get(JOB_SCRAPING_API_NAME, `/api/jobs/getScraperRequest`, {
    queryStringParameters: { page },
  });
};

export const createNewScrapeRequest = async (body) => {
  return await API.post(
    JOB_SCRAPING_API_NAME,
    `/api/jobs/createScraperRequest`,
    {
      body,
    }
  );
};
export const getAllScrapedJobs = async (body) => {
  return await API.post(JOB_SCRAPING_API_NAME, '/api/jobs/getJobsData', {
    body,
  });
};
export const updateScrapeRequest = async (body) => {
  return await API.post(
    JOB_SCRAPING_API_NAME,
    '/api/jobs/updateScraperRequest',
    {
      body,
    }
  );
};

export const downloadJobListings = async () => {
  return await API.get(JOB_SCRAPING_API_NAME, `/api/jobs/downloadData`, {
    responseType: 'blob',
  });
};
export const getAllKeywords = async () => {
  return await API.get(JOB_SCRAPING_API_NAME, `/api/jobs/getAllKeywords`, {});
};
export const getAllReasons = async () => {
  return await API.get(JOB_SCRAPING_API_NAME, `/api/jobs/globalData`, {});
};

export const markRelavancy = async (body) => {
  return await API.post(JOB_SCRAPING_API_NAME, '/api/jobs/updateJobs', {
    body,
  });
};

// update jobs

export const updateJobs = async (body) => {
  return await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/job-board/update-job-description',
    {
      body,
    }
  );
};
export const updateAlmaxCohort = async (body) => {
  return await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/almax-cohort-update',
    {
      body,
    }
  );
};

// filters params

export const getFilters = async () => {
  return await API.get(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/job-board/filter-params'
  );
};

// publish jobs

export const publishJobs = async (body) => {
  return await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/job-board/publish',
    {
      body,
    }
  );
};

// unpublish jobs

export const unPublishJobs = async (body) => {
  return await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/job-board/un-publish',
    { body }
  );
};


// getUserwoolfActivities
export const getUserwoolfActivities = async (courseType, userId) => {
  return API.get(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/get-student-activities', {
    queryStringParameters: {
      courseType,
      userId
    }
  });
};

export const getUserProjectSubmissions = async (courseType, userId) => {
  return API.get(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/get-projects', {
    queryStringParameters: {
      courseType,
      userId
    }
  });
};

export const generateProjectSubmissionLink = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/user-projects/submission/public-link', { body });
};

export const getUserQuizSubmissions = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/get-quiz', {
    body
  });
};

export const getUserPeerReviewSubmissions = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/get-peer-review', {
    body
  });
};
export const sendMeetingToWoolf = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/update-meetings', {
    body
  });
};
export const sendQuizToWoolf = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/update-quiz', {
    body
  });
};
export const sendProjectToWoolf = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/update-projects', {
    body
  });
};
export const sendPeerReviewToWoolf = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/woolf/update-peer-review', {
    body
  });
};
export const uploadIsa = async (body) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/userAlmax/uploadIsa', {
    body
  });
};

export const updateUserProgress = async (courseType, userId) => {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/course/v1/calculateUsersProgress', {
    body: {
      course: courseType,
      userIds: Array.isArray(userId) ? userId : [userId]
    }
  });
};
export const getTracks = async () => {
  return API.get(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/course/v1/tracks', {});
};

export async function updateStudentCertificates(data) {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/user/updateUserCertificate', {
    body: data
  });
}

export async function updateStudentCourse(data) {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/admin/users/courseChange', {
    body: data
  });
}

export const updateRefreshAlmaxExpiryDate = async ({ userId, courseType, date }) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/career/almax/refreh-almax-expiry-date',
    { body: { userId, courseType, date } }
  );
};

export const updateCoachPin = async (data) =>
  await API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/createInstructorToWhiteBoard', {
    body: data,
  });


export const updateInstructorStatus = async (data) =>
  await API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/admin/coach/inactiveInstructorToWhiteBoard', {
    body: data,
  });

export const getLiveSupport = async () =>
  await API.get(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/strapi/liveSupport', {});

export const updateLiveSupport = async (body) =>
  await API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/strapi/liveSupport', { body });

export async function updateStudentCourseChange (data) {
  return API.post(COURSE_LMS_GATEWAY_ENDPOINT_NAME, '/api/admin/users/courseChange', {
    body: data
  });
}

export const getListOfClassEvents = async () => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/events`
  );
};

export const createClassEvent = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/events`,
    { body }
  );
};

export const getSessionsByEvent = async (eventId) => {
  return await API.get(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/v2/classroom/sessions-by-event?eventId=${eventId}`
  );
};

// ── Enrollment Financial Details API ─────────────────────────────────────────

export const getEnrollmentList = async (params) => {
  const { page = 1, limit = 10, ...filters } = params;
  const queryParams = new URLSearchParams({ page, limit });
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value);
    }
  });
  return API.get(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment?${queryParams.toString()}`);
};

export const getEnrollmentById = async (id) =>
  API.get(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment/${id}`);

export const createEnrollment = async (body) =>
  API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/enrollment', { body });

export const updateEnrollment = async (id, body) =>
  API.put(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment/${id}`, { body });

export const deleteEnrollment = async (id) =>
  API.del(USER_API_GATEWAY_ENDPOINT_NAME, `/api/admin/v1/enrollment/${id}`);

export const getEnrollmentStatuses = async () =>
  API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/enrollment/statuses');

export const getEnrollmentConstants = async () =>
  API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/payment/constant');

export const createEnrollmentConstant = async (body) =>
  API.post(USER_API_GATEWAY_ENDPOINT_NAME, '/api/admin/v1/payment/constant', { body });

export const generatesTracksCertificates = async (body) =>
  await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/generateTracksCertificates',
    { body }
  );


export const getUserShortCourses = async (body) => {
  return await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    `/api/admin/users/shortCourses`,
    {  body}
  );
};

export const generatesShortCourseCertificates = async (body) =>
  await API.post(
    COURSE_LMS_GATEWAY_ENDPOINT_NAME,
    '/api/admin/users/generateShortCourseCertificates',
    { body }
  );